import RankGetCondition from '@/models/rank/apiParam/RankGetCondition';
import { Repository, RepositoryBase } from '@/repository/base';

/**
 * 検定関連リポジトリアクセス
 */
export default class RankRepository extends RepositoryBase {
  private repository = '/ranks';

  /**
   * 検定ランク検索
   *
   */
  getRanks() {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.get(`${this.repository}`, config);
  }

  /**
   * 検定ランク情報取得
   *
   * @param rankCode ランクコード
   */
  getRankInfo(rankCode: string, params: RankGetCondition = new RankGetCondition()) {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
      params: this.convert.serialize(params),
      paramsSerializer: (paramsObj: RankGetCondition) => this.paramsUrlEncode<RankGetCondition>(paramsObj),
    };
    return Repository.get(`${this.repository}/${rankCode}`, config);
  }

  /**
   * 体験版に紐づく問題取得
   */
  getTrialQuestions() {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.get(`${this.repository}/trial/questions`, config);
  }
}
